import logo from "./logo.png";
import backgroundFooter from "./bg-footer.png";

export const AppResource = {
  logo,
  backgroundFooter,
};
